import type { UserRepository } from '../../repositories/user/user.repository';
import { isApiError } from '@trading/infrastructure/src/api/types'

export default class UserController {
  constructor(
    private userRepository: UserRepository,
  ) {}

  async getCurrentUser() {
    try {
      return await this.userRepository.me()
    } catch (error: unknown) {
      if (isApiError(error)) {
        throw new Error('Не удалось получить пользователя ' + error.message)
      }
      throw new Error('что то пошло не так')
    }
  }


  // async subscribeToOrdersChannel(
  //   actionName: ChanelActionType,
  //   cb: (order: IncomingMessagePayload<OrderWSUpdate>) => void
  // ): Promise<undefined | CallableFunction> {
  //   if (!this.orderRepositoryWs || typeof this.orderRepositoryWs.subscribeToChannelsAction !== 'function') return
  //   return await this.orderRepositoryWs.subscribeToChannelsAction(actionName, cb)
  // }
}
